<div [style]="bottomStrips.length ? {} : { 'box-shadow': 'none' }" class="carousel-bottom-strip" id="carousel-bottom-strip">
    <div class="bottom-carousel" id="bottom-carousel">
        @for (strip of bottomStrips; track $index) {
            <bottom-strip
                [strip]="strip"
                (showFeedback)="showFeedbackModal($event)"
                (stripRemoved)="stripRemoved($event)"></bottom-strip>
        }
    </div>
    <div class="carousel-indicators">
        @if (indicators.length > 1) {
            @for (_ of indicators; track $index) {
                <div
                    class="indicator"
                    [class.active]="activeCarouselId === $index"
                    [class.not-active]="activeCarouselId !== $index"></div>
            }
        }
    </div>
</div>
